// extracted by mini-css-extract-plugin
export default {"hand":"RaisedHand_hand__hDQ8z"};